import { vaultRequest } from './request';

export const EXPIRATION_SECONDS = 30;
const EXPIRATION_TIME = `${EXPIRATION_SECONDS}s`;
const PERMISSIONS: string[] = [];

const USER_TOKEN_QUERY = `query UserToken($permissions: [String!], $expirationTime: String) {
  userToken(permissions: $permissions, expirationTime: $expirationTime) {
    accessToken
  }
}`;

export const createShortLivedToken = async (): Promise<string> => {
  const tokenRes = await vaultRequest(USER_TOKEN_QUERY, {
    permissions: PERMISSIONS,
    expirationTimeString: EXPIRATION_TIME,
  });
  const tokenResJson = await tokenRes.json();
  if (tokenResJson.errors && tokenResJson.errors.length > 0) {
    throw new Error('Could not create short lived token');
  }
  return tokenResJson.data.userToken.accessToken;
};
